export let BaseSettings = null; // NOSONAR - mutable singleton reference initialized at runtime
export function BaseGeneralSettingsInstanceCreator(settings) {
    BaseSettings = settings;
}
